import { makeStyles } from '@mui/styles';

export const useBookOrderStepStyles = makeStyles({
  list: {
    width: '100%',
    listStyle: 'none outside',
    margin: 0,
    padding: 0,
    '& li:last-child': {
      marginBottom: 0
    },
    '& li': {
      marginBottom: '8px'
    }
  }
});
